import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../hooks/useAuth';

const ParentPortalContext = createContext();

export const ParentPortalProvider = ({ children }) => {
    const { user, token } = useAuth();
    const [hijos, setHijos] = useState([]);
    const [selectedChildId, setSelectedChildId] = useState(() => {
        const saved = localStorage.getItem('orion_parent_selected_child');
        return saved ? parseInt(saved) : null;
    });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchHijos = async () => {
            if (!token) {
                setIsLoading(false);
                return;
            }

            try {
                // Use the shared api service
                const response = await api.get('/apoderado/hijos');

                const fetchedData = Array.isArray(response.data) ? response.data : [];
                setHijos(fetchedData);

                // Initialize selection if not set or invalid
                if (fetchedData.length > 0) {
                    const validChild = fetchedData.find(h => h.id === selectedChildId);
                    if (!validChild) {
                        setSelectedChildId(fetchedData[0].id);
                        localStorage.setItem('orion_parent_selected_child', fetchedData[0].id);
                    }
                }
            } catch (error) {
                console.error('Error fetching parent children:', error);
                setHijos([]); // Ensure it stays an array
            } finally {
                setIsLoading(false);
            }
        };

        fetchHijos();
    }, [token, user]);

    const selectChild = (id) => {
        if (!id) return;
        setSelectedChildId(parseInt(id));
        localStorage.setItem('orion_parent_selected_child', id);
    };

    const selectedChild = Array.isArray(hijos) ? hijos.find(h => h.id === selectedChildId) : null;

    return (
        <ParentPortalContext.Provider value={{
            hijos,
            selectedChildId,
            selectedChild,
            selectChild,
            isLoading
        }}>
            {children}
        </ParentPortalContext.Provider>
    );
};

export const useParentPortal = () => {
    const context = useContext(ParentPortalContext);
    if (!context) {
        throw new Error('useParentPortal must be used within a ParentPortalProvider');
    }
    return context;
};
